/* @jsx jsx */
import { css, jsx } from '@emotion/react';

import { Badge } from '../../display/Badge';
import type { Props as BadgeProps } from '../../display/Badge/Badge';

const badgeOverrides = css({
  '& > span': {
    minWidth: '26px !important',
  },
});

export default function PageNavigationBadge(props: BadgeProps) {
  return (
    <span css={badgeOverrides} data-zds>
      <Badge {...props}></Badge>
    </span>
  );
}
